module.exports = __webpack_public_path__ + "static/media/copy-link-icon.c3710952.svg";